import styled from 'styled-components';

export const MusicHallTransferSlipContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 22px;
  }
`;
